import styles from './PunchupErrorModal.module.css';

import { AlertCircle } from 'lucide-react';
import { ErrorModalProps } from './types';
import { FC } from 'react';
import { PunchupButton } from 'features/common/components/Punchup/primitives/buttons/PunchupButton';
import {
	PunchupDialogue,
	DialogIcon,
	DialogTitle,
	ButtonGroup,
} from 'features/common/components/Punchup/composites/dialogs/PunchupDialogue';
import { useTranslation } from 'react-i18next';

/**
 * Availability error dialog for the Send Tickets flow. Rendered through the shared
 * PunchupDialogue, which owns the token scrim, radius/padding, role=dialog/aria-modal,
 * accessible label, focus trap + restore, and Escape / backdrop-click close — so this
 * component is just the destructive icon + title + message + Dismiss content.
 */
export const PunchupErrorModal: FC<ErrorModalProps> = ({ closeModal }) => {
	const { t } = useTranslation();

	return (
		<PunchupDialogue onClose={closeModal}>
			<DialogIcon variant="destructive">
				<AlertCircle />
			</DialogIcon>
			<DialogTitle>{t('availability-Modal-Title')}</DialogTitle>
			<p className={styles.message}>{t('availability-Modal-Message')}</p>
			<ButtonGroup>
				<PunchupButton variant="outline" onClick={closeModal} text={t('button-dismiss')} type="button" />
			</ButtonGroup>
		</PunchupDialogue>
	);
};
